import { useState } from "react";
import { Button, Label, ListBox, Select } from "@heroui/react";

import {
  useDirections,
  useExportOrderProcessingQr,
} from "@/features/directions/use-directions.ts";

export const ExportDirectionProcessingOrdersModal = () => {
  const { data } = useDirections();

  const [value, setValue] = useState<string | null>(null);

  const { mutateAsync, isPending } = useExportOrderProcessingQr();

  const items =
    data?.data.map((direction) => ({
      key: direction.id.toString(),
      title: direction.fromCity.name + " - " + direction.toCity.name,
    })) ?? [];

  return (
    <div className="flex flex-col gap-4 p-4">
      <p className="text-neutral-600 font-medium">QR в накопитель</p>

      <Select
        selectedKey={value}
        onSelectionChange={(key) => setValue(key as string | null)}
      >
        <Label>Направление</Label>
        <Select.Trigger>
          <Select.Value />
          <Select.Indicator />
        </Select.Trigger>
        <Select.Popover>
          <ListBox items={items}>
            {({ key, title }) => (
              <ListBox.Item id={key} textValue={title}>
                {title}
              </ListBox.Item>
            )}
          </ListBox>
        </Select.Popover>
      </Select>

      <Button
        className="mt-auto"
        isPending={isPending}
        onPress={() => mutateAsync({ directionId: Number(value) })}
      >
        Распечатать QR
      </Button>
    </div>
  );
};
